import Vue from 'vue';
import Transitions from 'vue2-transitions';
import { MediaQueries } from 'vue-media-queries';

import { VueShopAuthPlugin } from '@holdingblachere/vue-shop-auth-plugin';
import '@holdingblachere/vue-shop-auth-plugin/dist/vue-shop-auth-plugin.css';

import { VueAuthPlugin } from '@holdingblachere/vue-auth-plugin';
import '@holdingblachere/vue-auth-plugin/dist/vue-auth-plugin.css';

/* eslint-disable */
require(`./assets/css/themes/base_theme.css`);
require(`./assets/css/themes/base_styles.css`);

if (process.env.VUE_APP_TYPE === 'FL') {
  require('./assets/css/themes/fl_theme.css');
  require('./assets/css/themes/fl_styles.css');
}

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/fr';
import App from './App.vue';
import router from './router';
import store from './store';

// i18n
import i18n from './i18n/i18n';

// Mixpanel
import mixpanel from './vendors/mixpanel/mixpanel';

// constant
import { MON_COMPTE_PROVIDER_NAME, AZURE_PROVIDER_NAME } from './vendors/providers';

Vue.prototype.$mixpanel = mixpanel;

Vue.use(Transitions);

Vue.use(ElementUI, { locale });

Vue.use(VueAuthPlugin, {
  store,
  router,
  applicationName: 'Mon Compte',
  shopAuthStoreModuleProviderName: 'mon-compte-shop-auth',
  azureADOidcProviderName: AZURE_PROVIDER_NAME,
  monCompteOidcProviderName: MON_COMPTE_PROVIDER_NAME,
});

Vue.use(VueShopAuthPlugin, {
  store,
  router,
  shopAuthStoreModulePrefix: 'shopAuth',
  shopAuthStoreModuleProviderName: 'mon-compte-shop-auth',
  afterLoginRoute: { name: 'Login' },
  afterLogoutRoute: { name: 'ShopLogin' },
});

Vue.config.productionTip = false;

const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);

new Vue({
  router,
  store,
  i18n,
  mediaQueries,
  render: (h) => h(App),
  async beforeCreate() {
    await this.$store.dispatch('auth/initState');
    await this.$store.dispatch('shopAuth/initState');
  },
}).$mount('#app');
